"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: flex/flex-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fflex%2Fflex-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexServiceClient = exports.GetFlexUserResponse = exports.GetFlexUserRequest = exports.UpdateFlexAccountResponse = exports.UpdateFlexAccountRequest = exports.CreateFlexAccountResponse = exports.CreateFlexAccountRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const account_1 = require("../account/account");
const auto_pay_1 = require("../billing/auto-pay");
const billed_account_1 = require("../billing/billed-account");
const amount_1 = require("../common/amount");
const flex_1 = require("./flex");
const protobufPackage = 'com.step.flex.proto';
function createBaseCreateFlexAccountRequest() {
    return { creditFirst: false, selectedCreditLimit: undefined };
}
exports.CreateFlexAccountRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditFirst)) {
            message.creditFirst = globalThis.Boolean(object.creditFirst);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditFirst !== undefined && message.creditFirst !== false) {
            obj.creditFirst = message.creditFirst;
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        return obj;
    },
    create(base) {
        return exports.CreateFlexAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateFlexAccountRequest();
        message.creditFirst = object.creditFirst ?? false;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        return message;
    },
};
function createBaseCreateFlexAccountResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.CreateFlexAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.CreateFlexAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateFlexAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseUpdateFlexAccountRequest() {
    return { creditFirst: undefined, selectedCreditLimit: undefined, autoPay: undefined };
}
exports.UpdateFlexAccountRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditFirst)) {
            message.creditFirst = globalThis.Boolean(object.creditFirst);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        if (isSet(object.autoPay)) {
            message.autoPay = auto_pay_1.AutoPayUpdate.fromJSON(object.autoPay);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditFirst !== undefined) {
            obj.creditFirst = message.creditFirst;
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        if (message.autoPay !== undefined) {
            obj.autoPay = auto_pay_1.AutoPayUpdate.toJSON(message.autoPay);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFlexAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFlexAccountRequest();
        message.creditFirst = object.creditFirst ?? undefined;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        message.autoPay = (object.autoPay !== undefined && object.autoPay !== null)
            ? auto_pay_1.AutoPayUpdate.fromPartial(object.autoPay)
            : undefined;
        return message;
    },
};
function createBaseUpdateFlexAccountResponse() {
    return { account: account_1.Account.fromPartial({}), billedAccount: billed_account_1.BilledAccount.fromPartial({}) };
}
exports.UpdateFlexAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
            billedAccount: isSet(object.billedAccount)
                ? billed_account_1.BilledAccount.fromJSON(object.billedAccount)
                : billed_account_1.BilledAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        if (message.billedAccount !== undefined) {
            obj.billedAccount = billed_account_1.BilledAccount.toJSON(message.billedAccount);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateFlexAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateFlexAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        message.billedAccount = (object.billedAccount !== undefined && object.billedAccount !== null)
            ? billed_account_1.BilledAccount.fromPartial(object.billedAccount)
            : billed_account_1.BilledAccount.fromPartial({});
        return message;
    },
};
function createBaseGetFlexUserRequest() {
    return {};
}
exports.GetFlexUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetFlexUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetFlexUserRequest();
        return message;
    },
};
function createBaseGetFlexUserResponse() {
    return { user: undefined };
}
exports.GetFlexUserResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.user)) {
            message.user = flex_1.FlexUser.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = flex_1.FlexUser.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.GetFlexUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFlexUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? flex_1.FlexUser.fromPartial(object.user)
            : undefined;
        return message;
    },
};
class FlexServiceClient {
    rpc;
    name = 'com.step.flex.proto.FlexService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/flex';
    methods = [{
            name: 'CreateFlexAccount',
            requestType: exports.CreateFlexAccountRequest,
            responseType: exports.CreateFlexAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdateFlexAccount',
            requestType: exports.UpdateFlexAccountRequest,
            responseType: exports.UpdateFlexAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdateAccount',
            requestType: exports.UpdateFlexAccountRequest,
            responseType: exports.UpdateFlexAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetFlexUser',
            requestType: exports.GetFlexUserRequest,
            responseType: exports.GetFlexUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Opens a Flex account.
     */
    createFlexAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update Flex account related settings.
     */
    updateFlexAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update Flex account related settings.
     * Deprecated: Use UpdateFlexAccount instead.
     */
    updateAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get Flex user.
     */
    getFlexUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.FlexServiceClient = FlexServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=flex-service.js.map